module.exports = __webpack_public_path__ + "components/country-flag/static/ls-b33fd668e3c21e3b9364dd6f8d9cfd96.svg";